module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-wrapper"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supportSimultaneousScreen),
      expression: "supportSimultaneousScreen"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    attrs: {
      "type": "radio",
      "value": "screen-camera"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "screen-camera")
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        _vm.onChange($event)
      },
      "__c": function($event) {
        _vm.selectedOption = "screen-camera"
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("screen-share-and-camera")) + "\n    ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    attrs: {
      "type": "radio",
      "value": "screen-only"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "screen-only")
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        _vm.onChange($event)
      },
      "__c": function($event) {
        _vm.selectedOption = "screen-only"
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("screen-share-only")) + "\n    ")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sharingScreenOnly || _vm.sharingScreenAndVideo),
      expression: "sharingScreenOnly || sharingScreenAndVideo"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    attrs: {
      "type": "radio",
      "value": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedOption, "disabled")
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        _vm.onChange($event)
      },
      "__c": function($event) {
        _vm.selectedOption = "disabled"
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t("stop-screen-share")) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51967d42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScreenMenuSelect.vue
// module id = 367
// module chunks = 1